module.exports = __webpack_public_path__ + "static/media/bullseye-pointer.de5ccabe.svg";